export const SOURCES_TEXT = {
    websites: {
        Total: "All Traffic",
        Combined: "All Traffic",
        MobileWeb: "Mobile Web Only",
        "Mobile Web": "Mobile Web Only",
        Desktop: "Desktop Only",
    },
    industryAnalysis: {
        Desktop: "Desktop Only",
    },
    apps: {
        Google: "Google Play",
        Apple: "Apple Store",
        google: "Google Play",
        apple: "Apple Store",
    },
    keywords: {
        Google: "Google Play",
    },
    keywordAnalysis: {
        Desktop: "Desktop Only",
    },
};
